import { render, staticRenderFns } from "./ExampleImgUploader.vue?vue&type=template&id=480d786b&scoped=true&"
import script from "./ExampleImgUploader.vue?vue&type=script&lang=js&"
export * from "./ExampleImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./ExampleImgUploader.vue?vue&type=style&index=0&id=480d786b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d786b",
  null
  
)

export default component.exports